<mat-form-field appearance="outline">
  <!--TODO: needs correct alignment etc-->
  <mat-icon matPrefix svgIcon="search_v2"></mat-icon>
  <input
    #searchfield
    type="search"
    matInput
    placeholder="{{'SEARCH.PLACEHOLDER' | translate}}"
    (input)="search($event.target?.value)"
    [value]="searchTerm$ | async" />
  <!-- TODO: should a 'clear-button' still be available? -->
  @if ((searchTerm$ | async)?.length > 0) {
    <div matSuffix class="search-suffix">
      <button mat-icon-button (click)="clearSearch()">
        <mat-icon svgIcon="close_v2"></mat-icon>
      </button>
    </div>
  }
</mat-form-field>
